import React from "react";
import { Link } from "react-router-dom";

/**
 * The line under a rental dispatch's Truck and Driver pickers (#815). The
 * pickers offer only fleet units and drivers that exist — there is no free
 * text — so when a list is empty this says so and links to where they are set
 * up. A list that failed to load is not "none set up".
 */
export function FleetPickerNotice({ failed, trucks, drivers }: { failed: boolean; trucks: number; drivers: number }) {
  if (failed) {
    return (
      <p role="alert" data-testid="fleet-picker-notice" className="text-xs text-fieldiq-text">
        Couldn't load trucks and drivers.
      </p>
    );
  }
  if (trucks > 0 && drivers > 0) return null;
  const what = trucks === 0 && drivers === 0 ? "trucks or drivers" : trucks === 0 ? "trucks" : "drivers";
  const link = "font-semibold underline underline-offset-2";
  return (
    <p data-testid="fleet-picker-notice" className="text-xs text-fieldiq-text">
      No {what} set up.{" "}
      {trucks === 0 && <Link className={link} to="/trucking/fleet">Add trucks</Link>}
      {trucks === 0 && drivers === 0 && " · "}
      {drivers === 0 && <Link className={link} to="/trucking/drivers">Add drivers</Link>}
    </p>
  );
}
